import { checkIfCreditCard } from "../objects/check_if_credit_card";
import { applyToCreditCard } from "../objects/apply_to_credit_card";
import addToSpendingHistoryTurnAmts from "../objects/add_to_spending_history_turn_amts";

export const applyCashOrCredit = (spendAmt, eventDesc, onValue, creditCategory, spendingHistory,
        currentCash, creditCardInfo) => {
    let errorFound = false
    let errorDesc = "";
    if (isNaN(+spendAmt)) {
            spendAmt = 0;
            errorDesc = "spendAmt is NaN";
            errorFound = true;
    }
    let spendAmtChange = +spendAmt;
    if (spendAmt < 0){
        spendAmtChange = +spendAmt * -1;
    }   
    spendingHistory.currentMonthSpendAmt += spendAmtChange;
        
    let chargeItemToCreditCard = false;
    chargeItemToCreditCard = 
        checkIfCreditCard(spendAmt, creditCardInfo, onValue, "cash");
     if (spendAmt !== 0){
        if (chargeItemToCreditCard === true){
            spendingHistory.turnCreditAmtArr = 
                addToSpendingHistoryTurnAmts(spendingHistory.turnCreditAmtArr, spendAmt);
        }else{
            spendingHistory.turnCashAmtArr = 
                addToSpendingHistoryTurnAmts(spendingHistory.turnCashAmtArr, spendAmt);
        }
    }    
    let updateCashOrCredit = "";
    if (chargeItemToCreditCard === true) {
        creditCardInfo = applyToCreditCard(creditCardInfo,
            spendAmt, eventDesc, creditCategory);
        updateCashOrCredit = "credit";
    } else {
        let cashAmt = +currentCash + +spendAmt;
        if (isNaN(cashAmt)) {
            cashAmt = +currentCash;
            errorDesc = "cash in NaN in applyCashOrCredit, spendAmt is: " + spendAmt;
            errorFound = true
        }
        updateCashOrCredit = "cash";
        currentCash = cashAmt.toString();
        
    }
    const returnObj = {updateCashOrCredit: updateCashOrCredit, currentCash: currentCash,
        creditCardInfo: creditCardInfo, errorFound: errorFound, errorDesc: errorDesc,
        spendingHistory: spendingHistory};
    return returnObj;

}
export default applyCashOrCredit;